// The one place the ticket search predicate is built. It was copied into five call sites and
// the comment term then survived in only one of them, so keep new surfaces pointing here.
//
// 'public' is for the request portal, whose lists already show only comments matching
// `IsPublic eq true and IsDeleted eq false`. Search must not reach past what is displayed.
export type CommentSearch = 'none' | 'all' | 'public';

export const ticketSearchFilter = (
  search: string,
  options: { matchId: boolean; comments: CommentSearch }
): string => {
  const terms = [`contains(Title, '${search}')`];

  if (options.comments === 'all')
    terms.push(`Comments/any(c: contains(c/Body, '${search}'))`);
  else if (options.comments === 'public')
    terms.push(`Comments/any(c: contains(c/Body, '${search}') and c/IsPublic eq true and c/IsDeleted eq false)`);

  if (options.matchId && /^\d+$/.test(search)) terms.push(`Id eq ${search}`);

  return `(${terms.join(' or ')})`;
};
